import { Content, TopBar } from "./components";

const LandingLayout = {
  TopBar,
  Content,
};

export default LandingLayout;
